module.exports = __webpack_public_path__ + "e6e9b3bef9baa6d66433e9f5dda88456.png";